import { useEffect, useContext } from "react";
import { TokenContext } from "../providers/token-provider";

/**
 * Refreshes tokenData onMount/onUnmount as a side effect
 */
export const useFreshToken = () => {
  const { updateToken } = useContext(TokenContext);

  useEffect(() => {
    updateToken(-1);

    return () => {
      updateToken(-1);
    };
  }, [updateToken]);
};
